module.exports = __webpack_public_path__ + "assets/img/chirp-post.cfe5562f.svg";